module.exports = __webpack_public_path__ + "img/icon-exam.3607538b.svg";